import * as shaka from 'shaka-player';

shaka.polyfill.installAll();

export {default as default} from './Shaka';